import React from 'react';
import { Button } from '../ui/Button';
import { Moon, Clock, ArrowDown } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full min-h-screen flex flex-col items-center justify-center py-12 md:py-20 px-4 overflow-hidden bg-slate-950" data-id="element-35">
      {/* Background Ambience */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-36">
        <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-indigo-900/20 rounded-full blur-[120px]" data-id="element-37" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-amber-900/10 rounded-full blur-[100px]" data-id="element-38" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center space-y-6 md:space-y-8" data-id="element-39">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-slate-900/80 border border-slate-800 text-amber-400 text-sm font-medium mb-4 animate-fade-in" data-id="element-40">
          <Moon className="w-4 h-4" data-id="element-41" />
          <span data-id="element-42">Para mujeres en perimenopausia</span>
        </div>

        {/* Headline */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-medium text-amber-50 leading-tight tracking-tight" data-id="element-43">
          Si te despiertas a las <span className="text-amber-400" data-id="element-44">3AM</span>, no
          necesitas "dormir".
          <br className="hidden md:block" data-id="element-45" /> Necesitas un guión.
        </h1>

        {/* Emotional Lead */}
        <div className="max-w-2xl mx-auto text-lg md:text-xl text-slate-300 space-y-4 leading-relaxed text-left md:text-center bg-slate-900/40 p-6 rounded-2xl border border-slate-800/50 backdrop-blur-sm" data-id="element-46">
          <p data-id="element-47">
            Te despiertas. No sabes por qué, pero lo sientes:{' '}
            <em className="text-amber-200/80" data-id="element-48">ya valió.</em>
          </p>
          <p data-id="element-49">
            ¿Calor? ¿Sudor? ¿Corazón acelerado? ¿Esa ansiedad rara que aparece
            cuando todo está en silencio?
          </p>
          <p data-id="element-50">
            Y entonces viene lo peor: tu mente empieza a correr… y tú empiezas a
            negociar con el sueño como si fuera una persona que ya te odia.
          </p>
        </div>

        {/* Product Image */}
        <div className="relative w-full max-w-2xl mx-auto mt-8 mb-8 md:mt-12 md:mb-12 group" data-id="element-51">
          <div className="absolute -inset-1 bg-gradient-to-r from-amber-500 to-indigo-600 rounded-2xl blur opacity-20 group-hover:opacity-30 transition duration-1000" data-id="element-52"></div>
          <img src="https://cdn.magicpatterns.com/uploads/e2KBrDZLEWDyxgHLjvjVdB/3am_otra_vez_portada.png" alt="3AM Otra Vez Protocolo en iPad" className="relative rounded-xl shadow-2xl border border-slate-800 w-full" data-id="element-53" />
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center gap-4" data-id="element-54">
          <Button size="lg" onClick={scrollToPricing} className="text-lg px-10 py-6" data-id="element-55">
            Quiero mi guión de las 3AM
          </Button>
          <p className="text-sm text-slate-500" data-id="element-56">
            Descarga inmediata • Protocolo paso a paso
          </p>
        </div>
      </div>

      <div className="absolute bottom-8 animate-bounce text-slate-600" data-id="element-57">
        <ArrowDown className="w-6 h-6" data-id="element-58" />
      </div>
    </section>;
}